/* eslint newline-before-return: "error" */
import { enableOrDisableSkill } from '../../Api/request/skills';
import UseAxios from '../../Api/http/http';
import {
  ENABLE_DISABLE_SKILL_DIALOG,
  ENABLE_DISABLE_ROLE_DIALOG,
  AUTHENTICATION_FAILED,
} from '../../Constants/strings';

export const handleDialogSubmit = async (
  data,
  setRows,
  setIsDialogOpen,
  handleSnackbar,
  setIsEdit,
) => {
  // Operations to be performed on enabling/disabling skill
  let isActive = data.is_active || data.isActive;
  isActive = Number(isActive) ? 0 : 1;

  const skillData = {
    skill_id: data.skill_id || data.id,
    is_active: isActive,
    last_updated_by: data.last_updated_by,
  };

  try {
    const response = await UseAxios(enableOrDisableSkill(skillData));
    // API call to enable/disable skill
    if (response.data.status !== 200) {
      const errorStatus = response.data.response.status;
      handleDialogClose(setIsDialogOpen, setIsEdit);
      handleSnackbar(
        errorStatus === 401
          ? AUTHENTICATION_FAILED
          : ENABLE_DISABLE_ROLE_DIALOG.OOPS_TRY_AGAIN,
        'warning',
        'enable-disable-warning-snackbar',
      );
      throw new Error('Failed to enable/disable skill');
    }
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (skillData.skill_id === row.id) {
          row.isActive = skillData.is_active; // Update the isActive value of updated row
        }

        // Close the dialog, after successful API response
        handleDialogClose(setIsDialogOpen, setIsEdit);
        const message = skillData.is_active
          ? ENABLE_DISABLE_SKILL_DIALOG.ENABLE.RESPONSE_SUCCESS
          : ENABLE_DISABLE_SKILL_DIALOG.DISABLE.RESPONSE_SUCCESS;
        handleSnackbar(message, 'success', 'enable-disable-success-snackbar');

        return row;
      }),
    );
  } catch (error) {
    console.error(error);
  }
};

export const handleDialogClose = (setIsDialogOpen, setIsEdit) => {
  // Close the dialog
  setIsDialogOpen(false);
  setIsEdit(false);
};
